(function () {
  'use strict';

  function initMethodDrawer() {
    var body = document.body;
    var drawer = document.getElementById('MethodMobileMenu');
    var overlay = document.querySelector('.mp-drawer-overlay');

    if (!body || !drawer || drawer.dataset.mpEnhanced === 'true') return;
    drawer.dataset.mpEnhanced = 'true';

    var openers = Array.prototype.slice.call(document.querySelectorAll('[data-mp-menu-open]'));
    var closeButton = drawer.querySelector('[data-mp-menu-close]');
    var toggles = Array.prototype.slice.call(drawer.querySelectorAll('[data-mp-submenu-toggle]'));
    var lastTrigger = null;

    function setSubmenuState(toggle, isOpen) {
      var submenu = toggle.nextElementSibling;
      if (!submenu || !submenu.classList.contains('mp-submenu')) return;

      toggle.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      submenu.classList.toggle('is-open', isOpen);
      submenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

      if (isOpen) {
        submenu.removeAttribute('inert');
      } else {
        submenu.setAttribute('inert', '');
      }
    }

    function closeOtherSubmenus(activeToggle) {
      toggles.forEach(function (toggle) {
        if (toggle !== activeToggle) setSubmenuState(toggle, false);
      });
    }

    function openDrawer(trigger) {
      if (trigger) lastTrigger = trigger;
      body.classList.add('mp-menu-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.setAttribute('aria-hidden', 'false');
      openers.forEach(function (opener) { opener.setAttribute('aria-expanded', 'true'); });

      window.requestAnimationFrame(function () {
        if (closeButton) closeButton.focus({ preventScroll: true });
      });
    }

    function closeDrawer(returnFocus) {
      body.classList.remove('mp-menu-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.setAttribute('aria-hidden', 'true');
      openers.forEach(function (opener) { opener.setAttribute('aria-expanded', 'false'); });
      toggles.forEach(function (toggle) { setSubmenuState(toggle, false); });

      if (returnFocus !== false && lastTrigger && document.contains(lastTrigger)) {
        window.requestAnimationFrame(function () {
          lastTrigger.focus({ preventScroll: true });
        });
      }
    }

    function syncSubmenu(toggle) {
      var submenu = toggle.nextElementSibling;
      var isOpen = Boolean(submenu && submenu.classList.contains('is-open'));
      if (isOpen) closeOtherSubmenus(toggle);
      setSubmenuState(toggle, isOpen);
    }

    function getFocusableItems() {
      return Array.prototype.slice.call(
        drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (item) {
        return !item.closest('[inert]') && item.getClientRects().length > 0;
      });
    }

    openers.forEach(function (opener) {
      opener.setAttribute('aria-controls', 'MethodMobileMenu');
      opener.setAttribute('aria-expanded', 'false');
    });

    toggles.forEach(function (toggle) {
      setSubmenuState(toggle, false);
    });

    if (overlay) overlay.setAttribute('aria-hidden', 'true');

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-mp-menu-open]');
      var closer = event.target.closest('[data-mp-menu-close]');
      var toggle = event.target.closest('#MethodMobileMenu [data-mp-submenu-toggle]');
      var drawerLink = event.target.closest('#MethodMobileMenu a[href]');

      if (opener) {
        window.requestAnimationFrame(function () { openDrawer(opener); });
        return;
      }

      if (closer) {
        window.requestAnimationFrame(function () { closeDrawer(true); });
        return;
      }

      if (toggle) {
        window.requestAnimationFrame(function () { syncSubmenu(toggle); });
        return;
      }

      if (drawerLink) {
        window.requestAnimationFrame(function () { closeDrawer(false); });
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (!body.classList.contains('mp-menu-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer(true);
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusableItems();
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }, true);

    window.addEventListener('resize', function () {
      if (window.innerWidth > 989 && body.classList.contains('mp-menu-open')) {
        closeDrawer(false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMethodDrawer);
  } else {
    initMethodDrawer();
  }
})();

(function () {
  'use strict';

  if (document.documentElement.hasAttribute('data-mp-electric-nav')) return;
  document.documentElement.setAttribute('data-mp-electric-nav', '');

  const selectors = [
    '.inline-header-nav .nav-rows li > a',
    '.inline-header-nav .nav-columns li > a'
  ];
  const selector = selectors.join(',');
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const canvas = document.createElement('canvas');
  canvas.className = 'mp-nav-electric-line';
  canvas.setAttribute('aria-hidden', 'true');
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  let active = null;
  let frame = 0;
  let width = 0;
  let time = 0;
  let last = 0;
  const pad = 16;

  function clear() {
    cancelAnimationFrame(frame);
    frame = 0;
    if (active) active.classList.remove('mp-electric-menu-target');
    active = null;
    canvas.remove();
  }

  function draw() {
    ctx.clearRect(0, 0, width + pad * 2, pad * 2);
    const path = new Path2D();
    const trace = new Path2D();
    const count = Math.max(2, Math.ceil(width / 3));
    const traceAt = (time * .09) % 1;
    let tracing = false;
    for (let i = 0; i <= count; i++) {
      const progress = i / count;
      const p = progress * Math.PI * 2;
      const wave = Math.sin(p * 17 + time * 2.4) * .5 + Math.sin(p * 31 - time * 3.1) * .32 + Math.sin(p * 57 + time * 1.7) * .18;
      const envelope = .6 + Math.pow(Math.sin(p * 3 - time * .7), 6) * 1.8;
      const offset = reduced.matches ? 0 : wave * envelope * .6 * Math.sin(progress * Math.PI);
      const x = pad + width * progress;
      const y = pad + offset;
      if (i) path.lineTo(x, y); else path.moveTo(x, y);
      const distance = (progress - traceAt + 1) % 1;
      if (distance < .11 && !reduced.matches) {
        if (tracing) trace.lineTo(x, y); else trace.moveTo(x, y);
        tracing = true;
      } else tracing = false;
    }
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.strokeStyle = '#064aff';
    ctx.shadowColor = '#084dff';
    ctx.shadowBlur = 13;
    ctx.lineWidth = 2;
    ctx.stroke(path);
    ctx.strokeStyle = '#438bff';
    ctx.shadowColor = '#2474ff';
    ctx.shadowBlur = 5;
    ctx.lineWidth = .95;
    ctx.stroke(path);
    ctx.shadowBlur = 0;
    ctx.strokeStyle = '#a7caff';
    ctx.lineWidth = .45;
    ctx.stroke(path);
    ctx.strokeStyle = '#c8ddff';
    ctx.shadowColor = '#347aff';
    ctx.shadowBlur = 5;
    ctx.lineWidth = .85;
    ctx.stroke(trace);
    ctx.shadowBlur = 0;
  }

  function measure() {
    if (!active || !active.isConnected || !desktop.matches || document.hidden) {
      clear();
      return false;
    }
    const bounds = active.getBoundingClientRect();
    if (!bounds.width || !bounds.height) { clear(); return false; }
    const walker = document.createTreeWalker(active, NodeFilter.SHOW_TEXT);
    const rects = [];
    let node;
    while ((node = walker.nextNode())) {
      const text = node.textContent;
      const start = text.search(/\S/);
      if (start < 0) continue;
      const range = document.createRange();
      range.setStart(node, start);
      range.setEnd(node, text.trimEnd().length);
      rects.push(...Array.from(range.getClientRects()).filter(rect => rect.width > 0));
    }
    if (!rects.length) { clear(); return false; }
    const left = Math.min(...rects.map(rect => rect.left));
    const right = Math.max(...rects.map(rect => rect.right));
    const bottom = Math.max(...rects.map(rect => rect.bottom));
    width = Math.min(right - left, bounds.width);
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.ceil((width + pad * 2) * dpr);
    canvas.height = pad * 2 * dpr;
    canvas.style.width = `${width + pad * 2}px`;
    canvas.style.height = `${pad * 2}px`;
    canvas.style.left = `${left - bounds.left - pad}px`;
    canvas.style.top = `${bottom - bounds.top + 3 - pad}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    draw();
    return true;
  }

  function tick(now) {
    if (!active || !active.isConnected || document.hidden || !desktop.matches) { clear(); return; }
    if (now - last >= 1000 / 30) {
      time += Math.min((now - last) / 1000, .06);
      last = now;
      draw();
    }
    frame = requestAnimationFrame(tick);
  }

  function show(anchor) {
    if (!desktop.matches || document.hidden || active === anchor) return;
    clear();
    active = anchor;
    active.classList.add('mp-electric-menu-target');
    active.appendChild(canvas);
    if (!measure()) return;
    if (!reduced.matches) {
      last = performance.now();
      frame = requestAnimationFrame(tick);
    }
  }

  function sync() {
    clear();
    if (!desktop.matches || document.hidden) return;
    const hovered = document.querySelector(selectors.map(value => value + ':hover').join(','));
    const focused = document.querySelector(selectors.map(value => value + ':focus-visible').join(','));
    if (hovered || focused) show(hovered || focused);
  }

  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch' || !(event.target instanceof Element)) return;
    const anchor = event.target.closest(selector);
    if (anchor) show(anchor);
  });
  document.addEventListener('pointerout', event => {
    if (active && active.contains(event.target) && !active.contains(event.relatedTarget) && !active.matches(':focus-visible')) clear();
  });
  document.addEventListener('focusin', event => {
    if (!(event.target instanceof Element)) return;
    const anchor = event.target.closest(selector);
    if (anchor && anchor.matches(':focus-visible')) show(anchor);
  });
  document.addEventListener('focusout', event => {
    if (active && active.contains(event.target) && !active.matches(':hover')) clear();
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') clear(); });
  document.addEventListener('visibilitychange', sync);
  document.addEventListener('shopify:section:unload', clear);
  window.addEventListener('pagehide', clear);
  window.addEventListener('blur', clear);
  window.addEventListener('resize', () => { if (active) measure(); });
  desktop.addEventListener('change', sync);
  reduced.addEventListener('change', sync);
})();
